<style src='@/resources/styles/payment.css' scoped></style>

<template>
    <div class='recharge popup show' ref="root" @click="maybeClose($event)">
        <PaymentOverlay
                v-show="showOverlay"
                v-bind:text="overlayText"
        />

        <button class='close' @click="close" />
        <h2 class='heading'>{{heading}}
            <img src="@/resources/images/icons/appetizer.png" width="20px" v-if="isAppetizer" />
            <img src="@/resources/images/icons/meal.png" width="30px" v-if="isFullCourse" />
        </h2>
        <div class='how-many'>
            <div class='batch-amount'>
                <span class='batch-free' />
            </div>
        </div>
        <div class='special-offer'>
            {{package.credits}} Credits
        </div>
        <div class='form'>
            <div class='card-info' ref="card">
            </div>
            <input type='email' name='email' placeholder='elon@tesla.com' class="email"
                   v-model="email"
                   @change="validateEmail"
                   v-bind:class="{error: this.errors.email}" />

            <div class='save-info'>
                <label class=" terms" v-bind:class="{error: this.errors.terms}">
                    <input type='checkbox' v-model="tos" @change="validateTerms">
                    I agree with the <a href="/tos" target="_blank">Terms &amp; Conditions</a> </label>
                <label><input type='checkbox' v-model="saveInfo">Save purchase info for future use</label>

                <label v-if="errorMsg" class="error_msg">{{errorMsg}}</label>
            </div>
            <button class='buy' @click="submit">
                <span class='label'>Buy</span>
                <span class='buy-price'>{{package.credits}} Credits - ${{package.price_formatted}} USD</span>
            </button>

            <div>
                <a href='https://www.stripe.com/' target='_blank'>
                    <div class='powered-by-stripe'></div>
                </a>
            </div>

            <div class="statement-name">
                This purchase will show as <strong>NAMINUS.COM</strong> on your card statement.
            </div>
        </div>
    </div>
</template>

<script>
  import PaymentOverlay from "./PaymentOverlay";
  import {mapActions, mapGetters} from 'vuex'
  import TxnStatusPoller from "../../../services/TxnStatusPoller";

  export default {
    name: 'PaymentForm',
    components: {
      PaymentOverlay
    },
    props: {
      package: Object,
      deets: Object
    },

    data() {
      return {
        stripe: null,
        elements: null,
        card: null,
        email: null,
        tos: true, //selected by default
        saveInfo: true,
        showOverlay: false,
        overlayText: "",

        errors: {
          email: false,
          terms: false,
          stripe: false,
        },
      }
    },

    computed: {
      ...mapGetters(['isEmailValid']),


      heading() {
        return `${this.package.name} - $${this.package.price_formatted}`
      },

      canSubmit() {
        if (! this.validate(true))
          return false;
        return this.errors.email === false && this.errors.terms === false;
      },

      errorMsg() {

        if (this.errors.stripe)
          return this.errors.stripe;

        if (this.errors.email)
          return "Please enter a valid email, so you won't lose access to your account.";


        if (this.errors.terms)
          return "Sorry, the lawyers said you gotta accept the terms & conditions :(";

        return null;
      },

       isAppetizer() {
          return this.package.id === "app";
       },

       isFullCourse() {
          return this.package.id === "full"
       },


    },


    mounted() {

      this.email = (this.deets.email) ? this.deets.email : ""; //is undefined if null
      //const stripeKey = this.intent['stripe_public_key'];
      const stripeKey = this.deets.stripe_key;

      this.stripe =  window.Stripe(stripeKey);

      this.elements = this.stripe.elements();

      const styles = {
        //@JR put in the css here, see example: https://github.com/stripe/elements-examples/blob/master/js/example1.js#L20
        base: {
          //Example:
          //fontFamily: 'Comic Sans',

          //more styles here
        }
      };


      this. card = this.elements.create("card",{ style: styles} );
      this.card.mount(this.$refs.card);

      this.card.addEventListener('change', ({error}) => {
        if (error)
          this.errors.stripe = error.message;
        else
          this.errors.stripe = false;
      })
    },


    methods: {
      ...mapActions(['reqPaymentIntent', 'prepareForMoney', 'txnStatus']),

      validate(silent) {
        if (! this.validateEmail(silent))
          return false;

        if (! this.validateTerms(silent))
          return false;

        return true;
      },

      validateEmail(silent) {
        const isValid = this.isEmailValid(this.email);

        if (isValid)
          this.errors.email = false;

        else if (silent !== true)
          this.errors.email = true;

        return isValid;

      },

      validateTerms(silent) {
        const isValid = this.tos === true;

        if (isValid)
          this.errors.terms = false;

        else if (silent !== true)
          this.errors.terms = true;

        return isValid;
      },

      maybeClose(event) {
        //sometimes closes modal when clicking away out of email box. disabled for now
        //if (event.target === this.$refs.root)
          //this.close();
      },

      close() {
        this.$emit("closed");
      },

      submit() {
        this.validate(false);
        if (! this.canSubmit)
          return;
        this.prepare();
      },



        //Save email in db so the receipt email will be set on the intent
        prepare(intent) {
            this.showOverlay = true;
            this.overlayText = "Processing..";
            const payload = {
                email: this.email
            };

            const that = this;
            this.prepareForMoney(payload).then(result => {

                if (result.ok !== true) {
                    that.errors.stripe = result.error;
                    that.showOverlay = false;
                    return;
                }
                that.getIntent();

            })
        },

       getIntent(){
            const payload = {};
            payload['package_id'] = this.package.id;

            const that = this;
            this.reqPaymentIntent(payload).then(intent => that.confirmPayment(intent))
        },


      confirmPayment(intent) {
        const that = this;
        const payload = {
          payment_method: {card: this.card}
        };
        window.console.log("Submitting payment", payload);

        this.errors.stripe = false; //clear any prev stripe errors
        this.stripe.confirmCardPayment(intent['secret'], payload)
          .then(result => {
              window.console.log("Stripe payment result:", result);
              if (result.error) {
                  that.errors.stripe = result.error.message;
                  that.showOverlay = false;
              } else {
                  window.console.log("Payment seems successful, starting poller");
                  that.overlayText = "Crediting your account..";
                  that.startPolling(intent);
              }
          });
      },

      startPolling(intent) {
          const poller = new TxnStatusPoller(intent.id, this.txnStatus, this.showThanks, this.showTimeoutError);
          poller.start();
      },


      showThanks(txn) {
        window.console.log("Showing thanks here", txn);
        this.showOverlay = false;
        this.close();
        this.$emit("paid", txn);
      },

      showTimeoutError() {
          this.showOverlay = false;
          this.errors.stripe =
              "It looks like your payment went through, but we had some trouble crediting your account. We will reach out to you shortly about this, and you can also email us at hi@naminus.com"
      }


    }
  }
</script>